export default __webpack_public_path__ + "static/media/banner-bottom.d454c629.jpg";